
export default function Footer() {
  return (
    <footer className="bg-stone-800 text-white py-12">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            <div>
              <h3 className="text-2xl font-bold mb-4">
                Masszázs17 – Budapest XVII. kerület
              </h3>
              <p className="text-stone-300 leading-relaxed">
                Relaxáció és fájdalomcsökkentés egy helyen. Barátságos és közvetlen masszázs, a mindennapi feszültség oldásához.
              </p>
            </div>
            
            <div>
              <h4 className="text-lg font-semibold mb-4">Szolgáltatások</h4>
              <ul className="space-y-2 text-stone-300">
                <li>• Svédmasszázs</li>
                <li>• Relaxációs masszázs</li>
                <li>• Stresszoldó masszázs</li>
                <li>• 30, 60, 90 perces kezelések</li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-lg font-semibold mb-4">Kapcsolat</h4>
              <div className="space-y-3 text-stone-300">
                <div className="flex items-center">
                  <i className="ri-map-pin-line mr-3 text-amber-400"></i>
                  1173 Budapest, Újlak utca 5.
                </div>
                <div className="flex items-center">
                  <i className="ri-phone-line mr-3 text-amber-400"></i>
                  <a href="tel:+36304815433" className="hover:text-amber-400 transition-colors cursor-pointer">
                    +36 30 481 5433
                  </a>
                </div>
                <div className="flex items-center">
                  <i className="ri-mail-line mr-3 text-amber-400"></i>
                  <a href="#kapcsolat" className="hover:text-amber-400 transition-colors cursor-pointer">
                    Kapcsolatfelvétel
                  </a>
                </div>
              </div>
            </div>
          </div>
          
          <div className="border-t border-stone-700 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <div className="mb-4 md:mb-0">
                <p className="text-stone-400 text-sm">
                  © 2024 Masszázs17 minden jog fenntartva
                </p>
              </div>
              
              <div className="flex items-center space-x-6">
                <div className="text-stone-400 text-sm">Kövess minket:</div>
                <a 
                  href="https://www.facebook.com/share/1BJN1EVrvB/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label="Facebook - Masszázs17"
                  title="Facebook - Masszázs17"
                  className="text-stone-300 hover:text-amber-400 transition-colors cursor-pointer"
                >
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a 
                  href="https://www.instagram.com/masszazs17bp" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label="Instagram - masszazs17bp"
                  title="Instagram - masszazs17bp"
                  className="text-stone-300 hover:text-amber-400 transition-colors cursor-pointer"
                >
                  <i className="ri-instagram-line text-xl"></i>
                </a>
                <a 
                  href="https://www.tiktok.com/@masszazs17bp" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label="TikTok - masszazs17bp"
                  title="TikTok - masszazs17bp"
                  className="text-stone-300 hover:text-amber-400 transition-colors cursor-pointer"
                >
                  <i className="ri-tiktok-line text-xl"></i>
                </a>
                <a 
                  href="https://readdy.ai/?origin=logo" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-stone-400 hover:text-amber-400 transition-colors text-sm cursor-pointer"
                >
                  Website Builder
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
